module.exports = __webpack_public_path__ + "static/media/44535067_2199893046752541_3029340897448820736_o.b0781378.jpg";